import React, { useState } from "react";
import "./Contact.css";

export default function Contact({ data }) {
  const [copied, setCopied] = useState(false);

  const copyEmail = () => {
    navigator.clipboard.writeText(data.email);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const items = [
    { icon: "✉️", label: "Email", value: data.email, href: `mailto:${data.email}` },
    { icon: "📞", label: "Phone", value: data.phone, href: `tel:${data.phone}` },
    { icon: "🔗", label: "LinkedIn", value: data.linkedin, href: data.linkedin },
    { icon: "🐙", label: "GitHub", value: data.github, href: data.github },
  ];

  return (
    <section id="contact" className="contact section">
      <div className="contact__bg" />
      <div className="container">
        <div className="contact__grid">
          <div className="contact__left">
            <span className="section-label">05 — Contact</span>
            <h2 className="contact__heading">
              Let's Build<br />
              Something<br />
              <span className="contact__heading-accent">Together.</span>
            </h2>
            <p className="contact__sub">
              Whether you have a project in mind, want to collaborate, or just want to say hi — my inbox is always open.
            </p>
            <div className="contact__actions">
              <a href={`mailto:${data.email}`} className="btn btn--primary">
                Send Email
              </a>
              <button className="btn btn--outline" onClick={copyEmail}>
                {copied ? "✓ Copied!" : "Copy Email"}
              </button>
            </div>
          </div>

          <div className="contact__right">
            {items.map((item) => (
              <div className="contact-item" key={item.label}>
                <span className="contact-item__icon">{item.icon}</span>
                <div className="contact-item__text">
                  <span className="contact-item__label">{item.label}</span>
                  {item.href ? (
                    <a href={item.href} target={item.href.startsWith("http") ? "_blank" : "_self"} rel="noreferrer" className="contact-item__val">
                      {item.value}
                    </a>
                  ) : (
                    <span className="contact-item__val">{item.value}</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
